import React from 'react';
import Icon from 'component/icon';

const FavoritesIcon = (props) => {
    const { myFavorites, page, className } = props;

    const colorClass = myFavorites.favoritePages.includes(page) ?
        'text-[#FFC729]' : 'text-[#B2B2B2]';

    const handleClickFavoriteIcon = (e) => {
        e.stopPropagation();
        myFavorites.onClickFavoriteIcon(page);
    };

    return !!myFavorites.open && (
        <Icon
            name="star"
            size={20}
            className={`ml-3 ${colorClass} ${className}`}
            onClick={handleClickFavoriteIcon}
        />
    );
};

export default FavoritesIcon;
